import script from "./b-water-s.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-water-s.vue?vue&type=script&lang=ts&setup=true"

import "./b-water-s.vue?vue&type=style&index=0&id=58638f02&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58638f02"]])

export default __exports__